import css from './PartsForRepair.module.css';
import { BsWrench } from 'react-icons/bs';
import { BsFillMicFill } from 'react-icons/bs';
import { BsCameraFill } from 'react-icons/bs';
import { BiSolidMessageDetail } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import {
  updateRepairPartStatus,
  updateRepairServiceStatus,
} from '../../../redux/cars/operations';
import toast from 'react-hot-toast';

export default function PartsForRepair({
  completedRepair,

  repair,
}) {
  const dispatch = useDispatch();
  console.log('repairRepair', repair);

  const handleChangePartStatus = (
    partID,
    repairID,
    workStatus,
    mechID,
    delStatus,
    is_warehouse
  ) => {
    if (delStatus !== 'received' && is_warehouse !== true) {
      toast.error(
        'Ремонт запчастини не може бути завершено,оскільки запчастина відсутня'
        // error.message або error - залежить від того, що повертає твій бекенд/thunk
      );
      return;
    } else {
      dispatch(
        updateRepairPartStatus({
          part_id: partID,
          repair_id: repairID,
          work_status: workStatus === 'waiting' ? 'done' : 'waiting',
          mechanic_id: mechID,
          // delivery_status: delStatus,
        })
      )
        .unwrap()
        .then(() => {
          toast.success('Статус запчастини успішно оновлено', {
            position: 'top-center',
            duration: 3000,
            style: {
              background: 'var(--bg-input)',
              color: 'var(--white)',
            },
          });
        })
        .catch(error => {
          console.error('Помилка при оновленні ремонту:', error);
          toast.error('Помилка оновлення статусу запчастини', {
            position: 'top-center',
            duration: 3000,
          });
        });
    }
  };

  const handleUpdateServiceStatus = (
    serviceID,
    repairID,
    mechID,
    workStatus
  ) => {
    dispatch(
      updateRepairServiceStatus({
        service_id: serviceID,
        repair_id: repairID,
        work_status: workStatus === 'waiting' ? 'done' : 'waiting',
        mechanic_id: mechID,
      })
    )
      .unwrap()
      .then(() => {
        toast.show({
          type: 'customSuccess',
          text1: 'Статус послуги успішно змінений',
        });
      })
      .catch(() => {
        toast.show({
          type: 'customError',
          text1: 'Щось сталося, спробуйте ще раз',
          // error.message або error - залежить від того, що повертає твій бекенд/thunk
        });
      });
  };

  return (
    <div className={css.wrapper}>
      {repair?.parts?.length > 0 && (
        <>
          {' '}
          <div className={css.titleBox}>
            <p className={css.title}>Запчастини</p>
          </div>
          <ul
            className={`${css.listOfItems} ${css.listParts} ${
              completedRepair && css.listCopmleted
            }`}
          >
            {repair?.parts?.map((part, index) => (
              <li
                key={index}
                className={`${css.item} ${
                  completedRepair && css.itemCompleted
                }`}
              >
                <p className={css.name}>
                  {part.name} {part.code}
                </p>
                {completedRepair ? (
                  <BsWrench
                    size={18}
                    className={`${css.icon} ${
                      part?.work_status === 'done' ? css.iconGreen : css.iconRed
                    }`}
                  />
                ) : (
                  <button
                    type="button"
                    className={`${css.btn} ${
                      part?.work_status === 'done' ? css.btnGreen : ''
                    }`}
                    onClick={() =>
                      handleChangePartStatus(
                        part?.id,
                        part?.repair_id,
                        part?.work_status,
                        part?.mechanic?.id,
                        part?.delivery_status,
                        part?.is_warehouse
                      )
                    }
                  >
                    <BsWrench size={18} className={css.icon} />
                  </button>
                )}
              </li>
            ))}
          </ul>
        </>
      )}

      {repair?.services?.length > 0 && (
        <>
          {' '}
          <div className={css.titleBox}>
            <p className={css.title}>Послуги</p>
          </div>
          <ul
            className={`${css.listOfItems} ${
              completedRepair && css.listCopmleted
            }`}
          >
            {repair?.services?.map((service, index) => (
              <li
                key={index}
                className={`${css.item} ${
                  completedRepair && css.itemCompleted
                }`}
              >
                <p className={css.name}>{service.name}</p>
                {completedRepair ? (
                  <BsWrench
                    size={18}
                    className={`${css.icon} ${
                      service?.work_status === 'done'
                        ? css.iconGreen
                        : css.iconRed
                    }`}
                  />
                ) : (
                  <button
                    type="button"
                    className={`${css.btn} ${
                      service?.work_status === 'done' ? css.btnGreen : ''
                    }`}
                    onClick={() =>
                      handleUpdateServiceStatus(
                        service?.id,
                        repair?.id,
                        service?.mechanic?.id,
                        service?.work_status
                      )
                    }
                  >
                    <BsWrench size={18} className={css.icon} />
                  </button>
                )}{' '}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
